import { gql } from '@apollo/client';
import { ASSESSMENT_DETAIL_FIELDS } from '../../fragments/assessment/assessmentDetail.fields';
import { GetAssessmentByApproverIdProps, GetAssessmentByIdProps, GetAssessmentByReferenceIdProps } from './assessment.types';
import { AssessmentType } from '../../../types';

export const GET_ASSESSMENT_BY_ASSESSMENT_ID = gql`
  ${ASSESSMENT_DETAIL_FIELDS}
  query GetAssessmentById($assessmentId:ID!) {
    assessment(assessmentId:$assessmentId){
      ...AssessmentDetailFields
    }
  }
`;

export function getAssessmentById({ client, assessmentId }: GetAssessmentByIdProps) {
  return client?.watchQuery<{ assessment: AssessmentType }>({
    query: GET_ASSESSMENT_BY_ASSESSMENT_ID,
    variables: {
      assessmentId,
    },
  });
}

export const GET_ASSESSMENTS_BY_REFERENCE_ID = gql`
  ${ASSESSMENT_DETAIL_FIELDS}
  query GetAssessmentsByReferenceId($referenceId:ID!) {
    assessmentsByReferenceId(referenceId:$referenceId){
      ...AssessmentDetailFields
    }
  }
`;

// eslint-disable-next-line max-len
export function getAssessmentsByReferenceId({ client, referenceId }: GetAssessmentByReferenceIdProps) {
  return client?.watchQuery<{ assessmentsByReferenceId: AssessmentType[] }>({
    query: GET_ASSESSMENTS_BY_REFERENCE_ID,
    variables: {
      referenceId,
    },
  });
}

export const GET_ASSESSMENTS_BY_APPROVER_ID = gql`
  ${ASSESSMENT_DETAIL_FIELDS}
  query GetAssessmentsByApproverId($approverId:ID!) {
    assessmentsByApproverId(approverId:$approverId){
      ...AssessmentDetailFields
    }
  }
`;

export function getAssessmentByApproverId({ client, approverId }: GetAssessmentByApproverIdProps) {
  return client?.watchQuery<{ assessmentsByApproverId: AssessmentType[] }>({
    query: GET_ASSESSMENTS_BY_APPROVER_ID,
    variables: {
      approverId,
    },
  });
}
